import type { BorderWidths } from '../types';

const borderWidths: BorderWidths = {
  0: 0,
  1: 1,
  2: 2,
};

export default borderWidths;
